const map = {
	"./arrow-down.svg": 9786,
	"./arrow-up.svg": 2601,
	"./back-arrow.svg": 5983,
	"./buttons/add.svg": 4277,
	"./buttons/analisys.svg": 3578,
	"./buttons/close.svg": 2832,
	"./buttons/deactivate.svg": 3854,
	"./buttons/details.svg": 5110,
	"./buttons/edit.svg": 3816,
	"./buttons/group-add.svg": 5199,
	"./buttons/reactivate.svg": 3064,
	"./buttons/trash.svg": 6386,
	"./icons/check_clean.svg": 2327,
	"./icons/close_clean.svg": 7299,
	"./icons/iconcheck.svg": 676,
	"./icons/person.svg": 4388,
	"./icons/warning.svg": 2865,
	"./illustrations/SouColaboradorAllied.svg": 3182,
	"./illustrations/SouRevendedorAllied.svg": 9394,
	"./loading-animated.svg": 8224
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;